import { render } from "./indexeightservice.vue?vue&type=template&id=794ff148"
import script from "./indexeightservice.vue?vue&type=script&lang=js"
export * from "./indexeightservice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__